export const keys = {
  students:      ['students'] as const,
  student:       (id: string | number) => ['students', String(id)] as const,
  lessons:       ['lessons'] as const,
  lesson:        (id: string | number) => ['lessons', String(id)] as const,
  notifications: ['notifications'] as const,
  templates:     ['templates'] as const,
  messages:      ['messages'] as const,
  jobs:          ['jobs'] as const,
  captures:      ['captures'] as const,
  capture:       (id: string | number) => ['captures', String(id)] as const,
  recurring:     ['recurring'] as const,
}
